import React from 'react';
import CloudOrgScoreDetails from './CloudOrgScoreDetails';

function CloudOrgScorePage() {
    return (
        <div style={{ padding: '24px' }}>
            <CloudOrgScoreDetails />
        </div>
    );
}

export default CloudOrgScorePage;
